import React from 'react';
import { Link } from 'react-router-dom';
import { Close } from 'core/icons';
import {
  SiteContainer,
  Flex,
  FlexItem
} from 'core/layout';
import { Logo, Button, Hairline } from 'elements';
import tulkojumi from 'utils/tulkojumi';
import MobileNav from './components/MobileNav';
import { MenuWrapper, StyledMobileMenu, TopGroup, VisibleOnMobile } from './styled';

class MobileMenu extends React.PureComponent {
  state= {
    open: false,
  };

  componentDidMount() {
    this._wrapper.addEventListener('click', this._onClick);
  }

  componentWillUnmount() {
    this._wrapper.removeEventListener('click', this._onClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this._close.focus();
    }
  }

  _onClick = (event) => {
    const outsideMenu = event.target !== this._menu;
    if (outsideMenu) {
      const { onClose } = this.props;
      onClose && onClose();
    }
  }

  render() {
    const {
      homeURL,
      primary,
      secondary,
      isOpen,
      onClose,
      teksti,
      fontSizeMenu,
      themeModeMenu,
    } = this.props;

    return (
      <MenuWrapper menuOpen={isOpen} innerRef={c => this._wrapper = c}>
        <SiteContainer>
          <Flex>
            <FlexItem basis={4 / 12}>

              <StyledMobileMenu innerRef={c => this._menu = c}>

                <div>
                  <TopGroup>
                    <Link
                      tabIndex='-1'
                      title={tulkojumi(teksti, 'liepaja_uz_sakumlapu')}
                      rel="noopener"
                      to={homeURL}
                    >
                      <Logo />
                    </Link>

                    <Button
                      tabIndex={isOpen ? '0' : '-1'}
                      innerRef={c => this._close = c}
                      type='text'
                      accent='secondary'
                      a11yLabel={tulkojumi(teksti, 'aizvert')}
                      icon={Close}
                      onClick={() => {
                        onClose && onClose();
                      }}
                    />
                  </TopGroup>

                  <MobileNav items={primary.items} isOpen={isOpen} />
                  <Hairline />
                  <MobileNav items={secondary.items} isOpen={isOpen} />

                  <VisibleOnMobile>
                    <Hairline />
                    {fontSizeMenu}
                    {themeModeMenu}
                  </VisibleOnMobile>
                </div>

              </StyledMobileMenu>
            </FlexItem>
          </Flex>
        </SiteContainer>
      </MenuWrapper>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/modules/Header/components/MobileMenu/MobileMenu.jsx